import { useQuery } from '@tanstack/react-query'
import { fetchAccessIdentity } from '@/lib/accessIdentity'

/**
 * React Query hook for fetching user identity from Cloudflare Access
 */
export function useIdentity() {
  return useQuery({
    queryKey: ['identity'],
    queryFn: fetchAccessIdentity,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: false, // Don't retry on failure - we have a fallback
  })
}
